import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-link',
  templateUrl: './card-link.component.html',
  styleUrls: ['./card-link.component.scss']
})
export class CardLinkComponent implements OnInit {

  @Input() cardTitle: any = '';
  @Input() cardDescription: any = '';
  @Input() cardLink: any = '';

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  irPara(rota: any) {
    
    if (rota == "/relatorio-sintetico") {
      if (sessionStorage.getItem('accessTokenJWT')) {
        this.router.navigate([rota]);
      } else {
        window.location.href = environment.urlPortal + "/entrar?redirectUrl=" + environment.urlRedirecionamentoRelatorioSintetico;
      }
    } else {
      this.router.navigate([rota]);
    }

  }
}
